import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import { Authenticator } from '@aws-amplify/ui-react';
import "./utils/i18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Authenticator.Provider><App /></Authenticator.Provider>);